var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatter2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89474 21C3.37895 21 3 19 3 18V13.0477C3.45318 14.3583 4.6455 14.9063 7 15H17C19.357 14.7752 20.532 14.1705 21 13.0078V18C21 20 19.7368 20.8334 19.1053 21H4.89474Z",
    stroke: "#636980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3252 9.4502C22.3251 12.3511 19.9263 14.7498 17.0254 14.75H7.0498C4.14881 14.7499 1.75011 12.3512 1.75 9.4502V9C1.75 7.44886 2.94886 6.25 4.5 6.25H19.5C21.056 6.25 22.2346 7.44793 22.3242 8.9707L22.3252 8.98535V9.4502Z",
    stroke: "#636980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.49998C8 4.50002 13.5 1.5 16.5 6.49998",
    stroke: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatter2);
export default __webpack_public_path__ + "static/media/Matter 2.0d11ae7c31fa100e47729e21e3a5db61.svg";
export { ForwardRef as ReactComponent };